/**
 * @generated SignedSource<<a34c35f81dec8f61dd44b8cfeb1d07d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BillingSettingsButton_info$data = {
  readonly billingSettings: {
    readonly enabled: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"BillingSettingsDialog_billingSettings">;
  };
  readonly " $fragmentType": "BillingSettingsButton_info";
};
export type BillingSettingsButton_info$key = {
  readonly " $data"?: BillingSettingsButton_info$data;
  readonly " $fragmentSpreads": FragmentRefs<"BillingSettingsButton_info">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BillingSettingsButton_info",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BillingSettings",
      "kind": "LinkedField",
      "name": "billingSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BillingSettingsDialog_billingSettings"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OwnerInfo",
  "abstractKey": null
};

(node as any).hash = "3c8dc884469dff5a1e696130d01522f0";

export default node;
